module.exports = __webpack_public_path__ + "static/img/6.a55089a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/hrm/6.png
// module id = K9wb
// module chunks = 0